import { Toast } from 'vant'
import { Auth, Mfe } from '@loca/mfe-vue3'

export default function beforeEach(to: any, _from: any, next: any) {
  const isMicroApp = Mfe.findMicroApp(to.path)
  const newTo = to
  const { auth } = newTo.meta
  newTo.meta.isMicroApp = isMicroApp

  if (to.name === 'Error' || to.name === '500') {
    // error 或 500 页，隐藏 loading，且直接放行
    Toast.clear()
    next()
  } else if (!auth || Auth.hasPermission(auth) || isMicroApp) {
    // 无需权限 或 为子应用页面，则直接放行
    if (newTo.meta.title) document.title = newTo.meta.title
    next()
  } else {
    next({ path: '/error' })
  }
}

